import './bml-certificates-banner.scss';
const TEMPLATE = `
<section class="case-banner certificates-banner container-fluid fade-up">
    <div class="case-circles-wrapper" data-animate-circles>
        <!-- Крапля в центрі -->
        <div class="case-drop-container">
            <img src="/images/case-drop.svg" alt="Drop" class="case-drop-image">
        </div>
        <!-- Кола -->
        <div class="case-circle case-circle-extra-large"></div>
        <div class="case-circle case-circle-large"></div>
        <div class="case-circle case-circle-medium"></div>
    </div>
    <h1 data-animate-child>Наші сертифікати <br>та акредитації</h1>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">

            </div>
            <div class="col-lg-6 col-md-6">

            </div>
        </div>
    </div>

</section>
`;

class BmlCertificatesBanner extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-certificates-banner', BmlCertificatesBanner);
